import { BaseButtonItem } from 'components/buttonGroup/model';
import { BaseTapItem } from 'components/tabList/model';

export const chartPeriodTypes: BaseButtonItem[] = [
  { type: '1d', label: 'chat.rewards_tracking_revenue_day_button' },
  { type: '1w', label: 'chat.rewards_tracking_revenue_week_button' },
  { type: '1M', label: 'chat.rewards_tracking_revenue_month_button' },
];

export const chartAssetTypes: BaseTapItem[] = [
  { type: 'entire', label: 'chat.rewards_tracking_revenue_total' },
  { type: 'persona,trigger-image', label: 'chat.rewards_tracking_revenue_characters' },
  { type: 'universe', label: 'chat.rewards_tracking_revenue_universes' },
  { type: 'scene', label: 'chat.rewards_tracking_revenue_scenes' },
];
